import React, { FC } from 'react';
import Link from 'components/commercetools-ui/atoms/link';
import { Reference } from 'types/reference';
import Image, { ImageProps } from 'frontastic/lib/image';

export interface Props {
  logo: ImageProps;
  logoLink: Reference;
  imageClassName?: string;
  onClick?: () => void;
}

const HeaderLogo: FC<Props> = ({ logoLink, logo, imageClassName, onClick }) => {
  return (
    <div className="relative left-0 px-10 md:left-40  md:mt-0 lg:left-0" onClick={onClick}>
      <a className={imageClassName} href="/">
        <Image media={logo?.media} fill style={{ objectFit: 'contain' }} alt={logo?.title} />
      </a>
    </div>
  );
};

export default HeaderLogo;
